import type { SITE_WORKING_CONDITION_MODULATION_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-working-condition-modulation-card/site-working-condition-modulation-card.fr.ts";

export const SITE_WORKING_CONDITION_MODULATION_CARD_ENGLISH_LOCALE = {
  title: "Modulations",
  lastSevenDays: "Last 7 days",
  pilotPresentOnSite: "Pilot on site : {yesno}",
} satisfies typeof SITE_WORKING_CONDITION_MODULATION_CARD_FRENCH_LOCALE;
